import React from "react";

function ManagementIconArrowBottom({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 10 10">
      <path
        id="Polygone_160"
        d="M4.462.645a.7.7,0,0,1,1.076,0L9.043,4.852A.7.7,0,0,1,8.505,6H1.495A.7.7,0,0,1,.957,4.852Z"
        transform="translate(10 6) rotate(180)"
        fill="#fafafa"
      />
    </svg>
  );
}

export { ManagementIconArrowBottom };
